<template lang="html">
	<div
		:class="[`vs-tabs-${color}`,`vs-tabs-position-${position}`]"
		class="con-vs-tabs vs-tabs" >
		<div
			class="con-ul-tabs">
			<ul
				ref="ul"
				:class="[`ul-tabs-${alignment}`]"
				class="ul-tabs vs-tabs--ul">
				<li
					v-for="(child,index) in children"
					ref="li"
					:class="{'activeChild':childActive == index}"
					:style="childActive == index ? styleTab : {}"
					class="vs-tabs--li"
					@mouseover="hover = true"
					@mouseout="hover = false">
					<button
						v-bind="child.attrs"
						:style="styleAlignIcon(child.icon)"
						class="vs-tabs--btn"
						type="button"
						@click="activeChild(index, false, child)"
						v-on="child.listeners">
						<div class="vs-tab-head">
							<div class="vs-tab-head__name">
								<vs-icon
									v-if="child.icon"
									:icon-pack="child.iconPack"
									:icon="child.icon"
									:color="color"
									class="vs-tabs--btn-icon"></vs-icon>
								<span v-if="child.label">{{ child.label }}</span>
							</div>
							<!-- <div
								v-if="!isNaN(child.counter.value) && child.counter.value !== 0"
								:class="{ 'vs-tab-head__counter_orange': child.counter.color }"
								class="vs-tab-head__counter"
							>{{child.counter.value <= 99 ? child.counter.value : 99}}</div> -->
							<div
								v-if="!isNaN(child.attrs.count) && child.attrs.count !== 0"
								:class="{ 'vs-tab-head__counter_orange': child.attrs.count > 0 ? 'orange' : undefined }"
								class="vs-tab-head__counter"
							>{{child.attrs.count <= 99 ? child.attrs.count : 99}}</div>
						</div>
					</button>

					<button
						v-if="child.tag"
						class="vs-tabs--btn-tag"
						@click="clickTag(child)"
					>
						<vs-icon
							:icon-pack="child.iconPack"
							:icon="child.tag"
							:color="child.tagColor"></vs-icon>
					</button>
				</li>
			</ul>
			<!-- <span
				:style="stylex"
				class="line-vs-tabs"/> -->
		</div>
		<div class="con-slot-tabs">
			<slot/>
		</div>
	</div>
</template>

<script>
import vsIcon from '../vs-icon/VsIcon'
import _color from '@/assets/utils/color.js'

export default {
	name:'VsTabs',
	components:{vsIcon},
	props:{
		value: {
			default: 0,
			type: [Number, String],
		},
		color:{
			default:'primary',
			type: String
		},
		tagColor:{
			default:'primary',
			type: String
		},
		alignment:{
			default:'left',
			type:String,
		},
		position:{
			default:'top',
			type:String
		}
	},
	data:()=>({
		topx:'auto',
		heightx:2,
		hover:false,
		children:[],
		childActive:0,
		leftx:0,
		widthx:0,
		these:false,
	}),
	computed:{
		styleTab(){
			return {
				color: _color.getColor(this.color,1),
			}
		},
		// stylex(){
		// 	return {
		// 		top: `${this.topx}px`,
		// 		left: `${this.leftx}px`,
		// 		width: `${this.widthx}px`,
		// 		height: `${this.heightx}px`,
		// 		background: `linear-gradient(30deg, ${_color.getColor(this.color,1)} 0%, ${_color.getColor(this.color,.5)} 100%)`,
		// 		boxShadow: `0px 0px 8px 0px ${_color.getColor(this.color,.5)}`,
		// 		transform: `scaleX(${this.these?1.3:1})`
		// 	}
		// }
	},
	watch: {
		// value(index) {
		// 	const activeIndex = this.parseIndex(index)
		// 	this.activeChild(activeIndex)
		// },
	},
	mounted(){
		const activeIndex = this.parseIndex(this.value)
		this.childActive = activeIndex
		this.$nextTick(() => {
			this.activeChild(activeIndex, true)
		})
	},
	// created() {
    //     window.addEventListener('resize', this.handleResize);
    //     // this.handleResize();
    // },
    // destroyed() {
    //     window.removeEventListener('resize', this.handleResize);
    // },
	methods:{
		// handleResize() {
		// 		this.activeChild(this.parseIndex(this.value), true)
			
		// },
		clickTag(child) {
			this.$emit('click-tag', child)
		},
		styleAlignIcon(icon){
			return icon ? 'display:flex;align-items:center' : ''
		},
		parseIndex(index) {
			let activeIndex = this.childActive
			if (index < 0) {
				activeIndex = 0
			} else if (index >= this.$children.length) {
				activeIndex = this.$children.length - 1;
			} else if (typeof this.$children[index].$attrs.disabled === 'undefined') {
				activeIndex = parseInt(index);
			}
			return activeIndex;
		},
		activeChild(index, initialAnimation, child){
            if (child && child.isButton) {
                this.$emit('setButtonAction')
                return
            }
			initialAnimation = !!initialAnimation;
			const elem = this.$refs.li[index]
			if(this.childActive == index && !initialAnimation){
				this.these = true
				elem.classList.add('isActive')
				setTimeout(()=>{
					elem.classList.remove('isActive')
					this.these = false
				}, 200);
			}
			this.$children.map((item,item_index)=>{
				if(item_index != index) {
					item.active = false
				}
			})
			if(this.childActive > index){
				this.$children[index].invert = true
				this.$children[this.childActive].invert = false
			} else {
				this.$children[this.childActive].invert = true
				this.$children[index].invert = false
			}
			this.$children[index].active = true
			this.childActive = index
			this.$emit('input', this.childActive)
			if(this.position == 'left' || this.position == 'right'){
				this.$children[index].vertical = true
			}
			this.changePositionLine(elem, initialAnimation)
			this.$emit('setActiveTab', index)
		},
		changePositionLine(elem, initialAnimation){
			if(this.position == 'left' || this.position == 'right'){
				this.topx = elem.offsetTop
				this.heightx = elem.offsetHeight
				this.widthx = 2
			} else {
				const update = () => {
					this.leftx = elem.offsetLeft
					this.widthx = elem.offsetWidth
					this.topx = (elem.offsetHeight + (elem.getBoundingClientRect().top - this.$refs.ul.getBoundingClientRect().top))
				}
				if (!initialAnimation) {
					update()
				} else {
					setTimeout(update, 100)
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.vs-tab-head {
	position: relative;
	display: flex;
	padding-left: 10px;
	padding-right: 10px;

	&__counter {
		position: absolute;
		right: -9px;
		top: -13px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-left: 4px;
		font-size: 11px;
		color: white;
		width: 18px;
		height: 18px;
		border-radius: 500px;
		background-color: #7A7A7A !important;

		&_orange {
			background-color: #FF9F42 !important;
		}
	}
}
.activeChild {
	&::before {
		content: '';
		position: absolute;
		bottom: 0;
		height: 3px;
		width: 100%;
		animation: activeChild ease .6s ;
		background: linear-gradient(30deg,rgba(var(--vs-primary),1),rgba(var(--vs-primary),.5))!important;
		box-shadow: 0 0 8px 0 rgba(var(--vs-primary),.4)!important;
		transition: all ease .5s;
	}
	@keyframes activeChild {
		from {
			opacity: 0;
			transform: scale(0);
			// width: 0;
		}
		to {
			opacity: 1;
			transform: scale(1);
			// width: 100%;
		}
	}
}
</style>
